<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import { customerService } from "../../../services/contactservice/customer.service";
import Swal from "sweetalert2";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customer Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      title: "Customer",
      customerData: null,
      breadCrumb: {}
    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData(this.$route.params.id);
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      customerService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.customerData = response;

          this.title = this.customerData.data.name + " - (" + this.customerData.data.code + ")";
        });
    },

    submitCancel: function() {

      Swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });

      
    }
  }
};
</script>

<template>
  <Layout>
   <PageHeader :items="[{
        text: $t('customer.list'),
        href: '/general/customer',
      }, this.breadCrumb]" :title="this.title" />
    <Loader :loading="fetchingStats">
    <div class="row">
      <div class="col-lg-12">

        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-user bx-tada font-size-20 align-middle me-2"></i>
                {{$t('customer.general')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-bookmark font-size-20 align-middle me-2"></i>
                {{$t('menuitems.booking.text')}}
              </div>
            </template>
   
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-dollar-circle font-size-20 align-middle me-2"></i>
                {{$t('menuitems.sale.text')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-book-bookmark font-size-20 align-middle me-2"></i>
                {{$t('menuitems.loan.text')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-history font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.history')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-down-arrow-alt font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.income')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-up-arrow-alt font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.expense')}}
              </div>
            </template>

          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx bx-reset font-size-20 align-middle me-2"></i>
                {{$t('menuitems.additionaloperation.list.buyback.text')}}
              </div>
            </template>

          </b-tab>
        </b-tabs>

      </div>
    </div>
    </Loader>
  </Layout>
</template>